module.exports = function getResource(label, vars = []) {
    const resources = { makeoverAt: 'Makeover at' };

    return resources[label];
};
